import { React, useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { Modal } from 'react-bootstrap'
import { enumUtil } from '../../utils/Enum';
import NotificationHandler from '../../utils/NotificationHandler';
import isNull from '../../utils/NullChecking';
import { ServerRequestProtected } from '../../utils/ServerDataRequest';
import HTMLParser from './NotesTab/ParserHtml';
import Addalert from './AddAlert';
import DeleteConfirmatiom from './DeleteConfirmation';
import Draggable from 'react-draggable';
import { FindFirstChild } from '../../utils/FindMenuOption';

const ActiveAlert = (props) => {
    let IsDeleteAllowed = FindFirstChild('Miscellaneous', 'Alters')?.IsDeleted

    let { ID, alertFrom, display, checkType, CallingFrom } = { ...props };
    const [isOpenAlertType, setisOpenAlertType] = useState(false);
    const [Contains, setAlertCode] = useState();
    const API_URL = enumUtil.controller.General
    const [isModalVisible, setModalVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [alertData, setAlertData] = useState([]);
    const [isOpenDelete, setIsOpenDelete] = useState(false)
    const [alertsave, setAlertSave] = useState(false)
    const [del, setDel] = useState(false)
    const [id, setID] = useState();
    const [isActive, setisActive] = useState(true)
    const modalRef = useRef(null);
    const closeModal = () => {
        setModalVisible(false);
    };
    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        }

        if (isModalVisible) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isModalVisible]);
    useEffect(() => {
        const searchCriteria = {
            [`${[alertFrom]}ID`]: ID,
            ...(checkType ? { PaymentType: checkType } : {}),
            CallingFrom: CallingFrom ? CallingFrom : '',
        };
        if (searchCriteria.PatientID || searchCriteria.ClaimID || searchCriteria.PaymentID || searchCriteria.CaregiverID || searchCriteria.PatientAppointmentID) {
            setIsLoading(true);
            ServerRequestProtected(API_URL + '/FindAlert', 'post', {
                TableName: enumUtil.enumAPITableName.Alert,
                SearchCriteria: searchCriteria
            })
                .then((response) => {
                    setAlertData(response);
                    setIsLoading(false);
                    setModalVisible(response.length > 0);
                })
                .catch((error) => {
                    // Handle error
                    setIsLoading(false);
                });
        }
    }, [alertsave]);



    //Save Api Call For IsActive 
    const handleSaveAlertType = async (AlertID, checked) => {
        console.log('Checked:', checked);

        let saveModal = {
            TableName: enumUtil.enumAPITableName.Alert,
            ID: AlertID,
            data: { IsActive: checked ? "1" : "0" },
            value: null
        };
        setIsLoading(true);
        ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
            .then((response) => {
                console.log("API Response:", response);
                setIsLoading(false);
                if (!isNull(response.id)) {
                    NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success);
                    setAlertSave(!alertsave)
                    // setaddAlertID(0);
                }
            }).catch((error) => {
                console.error("API Error:", error);
                setIsLoading(false);
                NotificationHandler(error.response.data, enumUtil.enumtoaster.warning);
            });
    }
    // const handleIsActiveChange = (AlertID) => {
    //     setisActive(!isActive);
    //     handleSaveAlertType(AlertID);
    //     console.log('IsActive check', isActive)
    //     console.log('Alert ID:', AlertID);
    // };
    const handleIsActiveChange = (checked, alertID) => {
        // console.log(recordID,'recordID');

        setAlertData(prev =>
            prev.map(item => {
                // console.log(item?.AlertID, 'RecordID', recordID);
                return item.AlertID === alertID
                    ? { ...item, IsActive: checked ? "True" : "False" }
                    : item;
            })
        );
        handleSaveAlertType(alertID, checked);
    };
    // const handleIsActiveChange = (checked, AlertID) => {
    //     setisActive(checked);
    //    
    //     console.log('IsActive check', checked);
    //     console.log('Alert ID:', AlertID);
    // };

    const AddAlertcode = (ID) => {
        setisOpenAlertType(true)
        setAlertCode(ID)
        closeModal()
    }
    const CloseCategory = () => {
        setisOpenAlertType(false)
    }
    const onCloseDelete = () => {
        setDel(false);
        setIsOpenDelete(false)
        if (alertData.length === 1) {
            setModalVisible(false)
        }
    }
    const handleDeleteModal = (ID) => {
        if (IsDeleteAllowed) {
            setID(ID)
            setIsOpenDelete(true)
        }
    }
    let PopupScreenAlert = "";
    if (isOpenAlertType) {
        PopupScreenAlert = <Addalert isOpenAlertType={isOpenAlertType} onClose={CloseCategory} Contains={Contains} Name={CallingFrom} />
    }
    let DeleteConfirmation = "";
    if (isOpenDelete) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenDelete} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.Alert} ID={id} onClose={onCloseDelete} />
    }
    return (
        <>
            {DeleteConfirmation}
            {PopupScreenAlert}
            <Modal
                show={isModalVisible}
                onHide={closeModal}
                centered
                backdrop={false}
                dialogClassName="app-modal modal-lg master_list_modal hk-alert__modal hk-alerts_box hk-alerts__zindx ar_export-excel_popup"
            >
                {/* <Modal show={isModalVisible} onHide={closeModal} centered dialogClassName="app-modal modal-lg master_list_modal hk-alert__modal hk-alerts_box hk-alerts__zindx ar_export-excel_popup"> */}
                <Draggable handle=".modal-body" defaultPosition={{ x: 26, y: 54 }}>
                    <Modal.Body ref={modalRef}>
                        <div className="d-flex align-items-center justify-content-between mb-12 px-10">
                            <div className="">
                                <p className="heading dark-clr fs-14">Alerts for {display}</p>
                            </div>
                            <i className="icon-x-cros fs-20 dark-clr" onClick={closeModal}></i>
                        </div>
                        <div className='mb-12 ar_scroll hover-scrollbar'>
                            <div className="row m-0 g-0 px-10 ">
                                <div className="opened-block m-0">
                                    {alertData?.length > 0 && alertData.map((item, index) => (
                                        console.log(item, 'recordID'),

                                        <div className="opened-block__lite ar-block-content" key={index}>
                                            <div className="opened-block__lite__boxes position-relative d-block p-2">

                                                <div className="">
                                                    <HTMLParser htmlContent={item.Contains} />
                                                </div>
                                                <div className='d-flex align-items-center justify-content-between my-2'>
                                                    {/* <div class="form-check form-switch radio_button"><input class="form-check-input" type="checkbox" id="mySwitch" name="Statuss" defaultChecked onClick={() => handleIsActiveChange(item.AlertID)} /></div> */}
                                                    <div className='d-flex gap-1 align-items-center m-0'>
                                                        <p className='fs-11 text font-m lh-11'>Active</p>
                                                        <div class="pe-0 m-0 insurance_radio_btn">
                                                            <div class="form-check form-switch radio_button mh-unset m-0">
                                                                <input
                                                                    class="form-check-input m-0"
                                                                    type="checkbox"
                                                                    id={`IsActive-${item.RecordID}`}
                                                                    name="IsActive"
                                                                    checked={item?.IsActive === "True" || item?.IsActive === true}
                                                                    onChange={e => handleIsActiveChange(e.target.checked, item.AlertID)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex align-items-center gap-1 m-0'>
                                                        <i className='icon-edit-pencil fs-12' onClick={() => AddAlertcode(item.AlertID)}></i>
                                                        <i className={IsDeleteAllowed ? 'icon-delete text-danger fs-12' : 'icon-delete text-danger fs-12 disabled'} onClick={() => handleDeleteModal(item.AlertID)}></i>
                                                    </div>
                                                </div>
                                                <div className="br-top-1 pt-2 za_br_light m-0">
                                                    <p className='text fs-11 font-m ar-light-color'>By, Date: <span className='font-r ps-1-5'>{item.UpdatedBy} {item.UpdatedDate}</span></p>
                                                    {/* <p><b>By:</b> {item.UpdatedBy}</p>
                                                <p><b>Date:</b> {item.UpdatedDate}</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                            <button className='btn btn-validate px-10 h-100' onClick={closeModal}>Close</button>
                        </div>
                    </Modal.Body>
                </Draggable>
            </Modal>
        </>
    )
}

export default ActiveAlert